import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { ProgressIndicator } from "../../common/progress/ProgressIndicator";
import DocumentPageContainer from "./DocumentPageContainer";

type RenderPDFProps = {
  width: number;
  contents: Buffer | Blob;
  onLoaded?: () => void;
};
export const DocumentPDF = ({ width, contents, onLoaded }: RenderPDFProps) => {
  //This configures pdfjs for react-pdf. Ideally, we could do this when react loads the SPA, but I don't know how.
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

  const [numPages, setNumPages] = useState<number>();
  const [pdfLoaded, setPdfLoaded] = useState<boolean>(false);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }): void => {
    setPdfLoaded(true);
    setNumPages(numPages);

    if (onLoaded) {
      onLoaded();
    }
  };

  const LoadingIndicator = () => <ProgressIndicator size={40} />;

  //TODO: the real wait time happens before this component is loaded while content is being retrieved; a good future improvement would be to show a loading state at the start of content being retrieved from the API

  return (
    <>
      <Document
        file={contents}
        noData={<LoadingIndicator />}
        loading={<LoadingIndicator />}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {pdfLoaded &&
          Array.from(new Array(numPages), (el, index) => (
            <DocumentPageContainer key={`page_${index + 1}`}>
              <Page
                width={width}
                renderAnnotationLayer={false}
                pageNumber={index + 1}
                noData={<LoadingIndicator />}
                loading={<LoadingIndicator />}
              />
            </DocumentPageContainer>
          ))}
      </Document>
    </>
  );
};
